import styled from 'styled-components';
import { Flex } from '@amzn/storm-ui';
import { PAGE_LAYOUT_TYPE } from 'src/app/slice';

export const FooterWrapper = styled.div<{ pageLayoutType: PAGE_LAYOUT_TYPE }>`
  box-sizing: border-box;
  padding: ${({ theme }) => theme.spacing.base.default};

  ${(props) =>
    [PAGE_LAYOUT_TYPE.STANDARD, PAGE_LAYOUT_TYPE.INTERNAL_STANDARD].includes(
      props.pageLayoutType,
    )
      ? `
        margin-inline-start: 64px;
      `
      : ''};
`;

export const MobileLinksWrapper = styled(Flex).attrs({
  direction: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  flexFlow: 'wrap',
  wrap: 'wrap',
  rowGap: 'xxsmall',
  columnGap: 'small',
})`
  margin-bottom: ${({ theme }) => theme.spacing.small.mobile};
  padding-inline: ${({ theme }) => theme.spacing.xsmall.mobile};
`;

export const DesktopToggleWrap = styled.div`
  font-size: 40px;
  width: 100%;
  text-align: center;
  margin-bottom: 16px;
`;
